// Wistia iframe embed for a muted, autoplaying, inline background clip. Browsers block
// unmuted autoplay, so `muted=true` is required; Wistia ignores `muted=1`.
export function wistiaBackgroundSrc(id: string) {
  return `https://fast.wistia.net/embed/iframe/${id}?seo=false&videoFoam=false&autoPlay=true&muted=true&playsinline=true`;
}

// Wistia iframe embed for a clip the viewer chose to play (e.g. in a dialog): sound on,
// autoplaying because the click that opened it counts as the user gesture browsers need.
export function wistiaPlayerSrc(id: string) {
  return `https://fast.wistia.net/embed/iframe/${id}?seo=false&videoFoam=true&autoPlay=true&playsinline=true`;
}

// Media ids from bouncieweb's config `wistiaMediaIds`.
export const WISTIA_MEDIA_IDS = {
  transformingFleetVehicles: "khigodlc9u",
} as const;
